import React, { createContext, useReducer } from 'react'
import { initialState, UserReducer } from './UserReducer'

// Create a Context
export const UserContext = createContext()

const AuthProvider = ({children}) => {
    
    const [state, dispatch] = useReducer(UserReducer, initialState)  
    
    const login = async data => {
        const LOGIN_URL = `https://www.durgacollege.in/dashboard/backend/login.php`;
        const params = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        }
        
        try {
          dispatch({ type: 'REQUEST_LOGIN' })
          let response = await fetch(LOGIN_URL, params)
          let data = await response.json()
          if (response.status === 200 && data.status) { 
            dispatch({ type: 'LOGIN_SUCCESS', payload: data.status });
            localStorage.setItem('loginuser', JSON.stringify(data.status));
            return data            
          }
          dispatch({ type: 'LOGIN_ERROR', payload: data.error });
          return            
        } catch (error) {
          dispatch({ type: 'LOGIN_ERROR', error: error });
        }
    }

    const logout = () => {
      dispatch({ type: 'LOGOUT'})
      localStorage.removeItem('loginuser')
    }

    return (
        <>
            <UserContext.Provider value={{...state, login, logout}}>
              {children}
            </UserContext.Provider>
        </>
    )
}

export default AuthProvider
